import { IRegistration } from "../registration";

export interface IQaRegistrationGetRegistrationResponse {
    data: {
        success: boolean,
        results: IRegistration
    }
}